import moment from 'moment';
import React, { useState } from 'react';
import { LightgalleryItem, LightgalleryProvider } from 'react-lightgallery';
import { useSelector } from 'react-redux';

import magnify from '../../assets/img/icons/magnifying-glass-plus.svg';
import noImg from '../../assets/img/no-image.png';
import noScreenshot from '../../assets/img/screenshot_2.svg';
import {
  IconArrow,
  Image,
  ImageContainer,
  MagnifyIcon,
} from './evidenceStyles';

const PhotoItem = props => {
  const {item, image, evidenceImageId } = props;
  const [hover, setHover] = useState(false);
  const [imageId, setImageId] = useState(-1);
  const evidenceImageList = useSelector(state => state.evidence.evidenceList);

  const handleMouseEnter = () => {
    setHover(true);
    setImageId(evidenceImageId);
  };

  const handleMouseLeave = () => {
    setHover(false);
    setImageId(-1);
  };
  // console.log(evidenceImageList);
  // if (!evidenceImageList.length) return null;
  
  return (
      <LightgalleryItem
        src={image || noImg}
        // key={k}
        group="group"
        subHtml={`<div class="col-xs-12 col-md-4 screenshot-desc-col">
                      <div class="row">
                        <p class="screenshot-desc-title">Task Code: </p>
                        <p class="screenshot-desc-text">
                        ${item?.task_code}
                        </p>
                      </div>
                      <div class="row screenshot-desc-row-mobile">
                        <p class="screenshot-desc-title">Office Number: </p>
                        <p class="screenshot-desc-text">
                        ${item?.office_name}</p>
                      </div>
                    </div>
                      <div class="col-md-4 col-xs-12  screenshot-desc-col">
                      <div class="row" style="justify-content: center;">
                        <p class="screenshot-desc-title">Employee Name: </p>
                        <p class="screenshot-desc-text">
                        ${item?.created_by || 'Unknown'}</p>
                      </div>
                      
                    </div>
                    <div class="col-md-4 col-xs-12 screenshot-desc-col">
                      <div class="row" style="justify-content: flex-end">
                        <p class="screenshot-desc-title">Time Stamp: </p>
                        <p class="screenshot-desc-text">${moment(
                          item.created_at,
                        )
                          .local()
                          .clone()
                          .startOf('hour')
                          .format('h:mm A')} -${' '}
                        ${moment(item.created_at)
                          .local()
                          .add(1, 'hour')
                          .startOf('hour')
                          .format('h:mm A')}</p>
                      </div>
                      <div class="row screenshot-desc-row-mobile" style="justify-content: flex-end;">
                        <p class="screenshot-desc-title">Image Uploaded At: </p>
                        <p class="screenshot-desc-text">${moment(
                          item.created_at,
                        )
                          .local()
                          .format('h:mm A, Do MMM, YYYY')}</p>
                      </div>
                    </div>`}
      >
        <ImageContainer
          isHovered={hover}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Image src={image || noScreenshot} isHovered={hover} />
          {image && hover && imageId == evidenceImageId && (
            <MagnifyIcon>
              <img src={magnify} height="25px" width="25px" />
            </MagnifyIcon>
          )}
        </ImageContainer>
      </LightgalleryItem>
  );
};

export default PhotoItem;
